import React, { useState, useEffect } from 'react';
import api from '../services/api';

function Dashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await api.get('/admin/stats');
      setStats(response.data);
    } catch (error) {
      console.error('Failed to fetch stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Dashboard</h1>
        <p className="page-subtitle">Overview of your Learn Witch Me platform</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-value">👥 {stats?.total_users || 0}</div>
          <div className="stat-label">Total Users</div>
        </div>

        <div className="stat-card">
          <div className="stat-value">✨ {stats?.active_users_7d || 0}</div>
          <div className="stat-label">Active Users (7d)</div>
        </div>

        <div className="stat-card">
          <div className="stat-value">🌍 {stats?.total_languages || 0}</div>
          <div className="stat-label">Languages</div>
        </div>

        <div className="stat-card">
          <div className="stat-value">📚 {stats?.total_lexemes || 0}</div>
          <div className="stat-label">Lexemes</div>
        </div>

        <div className="stat-card">
          <div className="stat-value">📝 {stats?.total_translations || 0}</div>
          <div className="stat-label">Translations</div>
        </div>
      </div>

      <div className="card">
        <h2 style={{ marginBottom: '16px' }}>Quick Actions</h2>
        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          <button className="btn btn-primary">Add Language</button>
          <button className="btn btn-primary">Add Lexeme</button>
          <button className="btn btn-primary">Import Translations</button>
          <button className="btn btn-secondary">View Users</button>
        </div>
      </div>

      <div className="card">
        <h2 style={{ marginBottom: '16px' }}>Recent Activity</h2>
        <p style={{ color: 'rgba(243, 234, 255, 0.6)' }}>
          Activity tracking coming soon...
        </p>
      </div>
    </div>
  );
}

export default Dashboard;

